<div>
  <div class="flex flex-row items-center gap-3 text-lg font-bold" (click)="showConfig = !showConfig">
    <label class="cursor-pointer font-bold">Advanced Scan Configurations</label>
    <i [ngClass]="['pi', 'font-bold', 'cursor-pointer', showConfig ? 'pi-chevron-down' : 'pi-chevron-right']"></i>
  </div>
  <div class="mt-3">
    @if (showConfig) {
      <label
        >Below are the default configurations for the active scan. Modifying them will change the speed, network impact, bandwidth, and reliability of
        the scan results</label
      >
    }
  </div>
  @if (showConfig) {
    <microsec-form-builder #fb [isPage]="true" [formPadding]="'1.5rem 0 0 0'" [fields]="fields" [shouldShowActionButtons]="false" />
  }
</div>
